import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'bom-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss'],
})
export class VideoComponent implements OnInit {
  @Input()
  videoId: string;

  @Input()
  width = 400;

  @Input()
  height = 300;

  @Input()
  imageUrl: number;

  videoIframeHtml: SafeHtml;
  videoUnlocked$ = new BehaviorSubject<boolean>(false);

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit() {
    const iframe =
      `<iframe src="https://player.vimeo.com/video/${this.videoId}?autoplay=1" ` +
      `width="${this.width}" height="${this.height}" ` +
      `allow="autoplay" frameborder="0" allowfullscreen></iframe>`;
    this.videoIframeHtml = this.sanitizer.bypassSecurityTrustHtml(iframe);
  }
}
